export function parseDateField(value: string | Date | null): Date | null {
  if (!value) {
    return null;
  }

  return new Date(value);
}

export function transformDateToBackendFormat(date: Date | null) {
  if (date === null) {
    return null;
  }

  const month = date.toLocaleString('en-US', { month: 'long' });
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${month}, ${day} ${year} ${hours}:${minutes}:${seconds}`;
}
